<template>
  <div>
    <page-layout
      :noSideBar="true"
      headerBackgroundColor="#1C3452"
    >
      <template v-slot:headerContent>
        <div class="row">
          <span
            :style="`color: white`"
            class="title"
          >
            Your Settings
          </span>
        </div>
        <div class="row items-center" style="position: relative">
          <span class="headerText text-white">
            Customise your settings
          </span>
        </div>
      </template>
      <template v-slot:content>
        <div class="row">
          <q-tabs v-model="tab" no-caps inline-label align="left" class="text-accent2 tabsStyle">
            <q-tab name="user" label="User">

            </q-tab>
            <q-tab name="organisation" label="Organisation">

            </q-tab>
          </q-tabs>
        </div>
        <router-view></router-view>
      </template>
    </page-layout>
  </div>

</template>

<script>
import { mapGetters } from "vuex";
import PageLayout from "@/components/pageLayout/pageLayout.vue";


export default {
  components: {
    PageLayout
  },
  computed: {
    ...mapGetters({

    }),
  },
  props: {
    source: String,
  },
  watch: {
    $route: function () {
      this.handleRoute();
    },
    tab: function() {
      this.$router.push(`/settings/${this.tab}`);
    }
  },
  data: () => ({
    tab: null
  }),
  mounted() {
    this.handleRoute();

  },
  methods: {
    handleRoute() {
      if (this.$route.path.includes('user')) {
        this.tab = 'user';
      } else if (this.$route.path.includes('organisation')) {
        this.tab = 'organisation';
      }
    }

  },
};
</script>

<style lang="scss" >
.tabsStyle {
  .q-tab__label {
    font-size: 1rem !important;
    font-weight: 700 !important;
  }

}
</style>

